import { render, staticRenderFns } from "./step-three.vue?vue&type=template&id=b5f26044&scoped=true&"
import script from "./step-three.vue?vue&type=script&lang=js&"
export * from "./step-three.vue?vue&type=script&lang=js&"
import style0 from "./step-three.vue?vue&type=style&index=0&id=b5f26044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f26044",
  null
  
)

export default component.exports